export const base64ToString = (str: string, fallback = ''): string => {
  try {
    return Buffer.from(str, 'base64').toString();
  } catch (e) {
    return fallback;
  }
};
